<template>
<div class="pageContainer">

  <div class="asideContainer">

    <div class="size">
      <div class="title">{{'物件别不良推移'}}
        <el-select v-model="wuJianId" @change="renderAllEcharts" clearable placeholder="物件名称" size="small" class="wujian_size">
          <el-option
              v-for="item in wuJianNames"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div v-loading="wuJianChartLoading" element-loading-text="数据加载中" style="width: 470px;height: 190px" id="wuJianJiaGong"/>
    </div>

    <div class="size" id="main">
      <div class="title">
        <span>{{'加工日不良率,不良数量,重量'}}</span>
        <el-date-picker v-model="dayBad" @change="getDayChart" format="YYYY 年 M 月" value-format="YYYY-M-1" type="month" placeholder="选择月份" style="width: 130px" size="small"/>
      </div>
      <div v-loading="dayBadLoading" element-loading-text="数据加载中" style="width: 470px;height: 190px" id="dayBadJiaGong"/>
      <!--        <div class="summary">
                <div class="messageCard">
                  <div class="message" style="background-color: #409eff">{{'月入库数'}}</div>
                  <h2>549</h2>
                </div>

                <div class="messageCard"><div class="message" style="background-color: #40a9ff">{{'月检查数'}}</div>
                  <h2>239</h2>

                </div>

                <div class="messageCard">
                  <div class="message" style="background-color: #f89898">{{'日不良数'}}</div>
                  <h2>49</h2>
                </div>

                <div class="messageCard">
                  <div class="message" style="background-color: #f56c6c">{{'日不良率'}}</div>
                  <h2>14%</h2>
                </div>

              </div>-->
    </div>

  </div>

  <div class="asideContainer">

    <div class="size" style="height: 345px">
      <div class="title">
        <span>{{'不良项目数量占比'}}</span>
        <div class="space-between">
          <el-date-picker v-model="pieDate.year" @change="getPieChart" format="YYYY 年" value-format="YYYY" clearable type="year" placeholder="年" style="width: 80px; margin-right: 10px" size="small"/>
          <el-date-picker v-model="pieDate.month" @change="getPieChart" format="MM 月" value-format="MM" clearable type="month" placeholder="月" style="width: 70px; margin-right: 10px" size="small"/>
          <el-date-picker v-model="pieDate.day" @change="getPieChart" format="DD 日" value-format="DD" clearable type="day" placeholder="日" style="width: 70px;" size="small"/>
        </div>
      </div>
      <div v-loading="pieChartLoading" element-loading-text="数据加载中" style="width: 470px;height: 320px" id="pieJiaGong"/>
    </div>

  </div>

</div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "JiaGongZhiJianPage",
  data(){
    return{
      dayBad:this.getDateFormat(),
      pieDate:{
        year:new Date().getUTCFullYear().toString(),
        month:'',
        day:''
      },
      wuJianId:'B00270',
      wuJianNames:[],
      /*物件别玻璃不良推移*/
      optionWuJian: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          //data: ['Evaporation', 'Precipitation', 'Temperature']
        },
        xAxis: [
          {
            type: 'category',
            data: [2104,2105,2106,2107,2108,2109,2110,2111,2112,2201,2202,2203],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '不良数量',
            min: 0,
            max: 10,
            interval: 2,
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            name: '不良率',
            min: 0,
            max: 100,
            interval: 20,
            axisLabel: {
              formatter: '{value}'
            }
          }
        ],
        series: [
          {
            name: '不良数量',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: [
              41, 63, 71, 15, 18, 23, 35, 46, 21, 23, 23, 41
            ]
          },
          {
            name: '目标',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + '%';
              }
            },
            data: [
              14, 12, 17, 15, 18, 23, 35, 46, 21, 23, 22, 24
            ]
          },
          {
            name: '实绩',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + '%';
              }
            },
            data: [24, 14, 36, 28, 10, 10, 18, 28, 23, 16, 12, 26]
          }
        ]
      },
      wuJianChartLoading:false,
      /*日不良率*/
      optionDayBad: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '日不良数量',
            min: 0,
            max: 10,
            interval: 2,
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            name: '日不良率',
            min: 0,
            max: 100,
            interval: 50,
            axisLabel: {
              formatter: '{value} %'
            }
          }
        ],
        series: [
          {
            name: '日不良数量',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: [
              2, 4, 7, 23, 25, 76, 135, 162, 32, 20, 6, 3, 2, 4, 7, 23, 25, 76, 135, 162, 32, 20, 6, 3, 2, 4, 7, 23, 25, 76, 135, 162, 32, 20, 6, 3
            ]
          },
          {
            name: '日不良率',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + ' %';
              }
            },
            data: [
              2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 23.6, 12.2, 8.7, 18.8, 6.0, 2.3,2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 23.6, 12.2, 8.7, 18.8, 6.0, 2.3,2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 23.6, 12.2, 8.7, 18.8, 6.0, 2.3
            ]
          }
        ]
      },
      dayBadLoading:false,
      /*不良项目数量占比*/
      optionPie:{
        title: {
          //text: 'Referer of a Website',
          //subtext: 'Fake Data',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 0,
          data: [
            { value: 1048, name: '二次胶不良' },
            { value: 735, name: '内脏' },
            { value: 580, name: '开裂' },
            { value: 484, name: '变形' },
            { value: 84, name: '擦伤,划伤' },
            { value: 44, name: '膜不良' },
            { value: 84, name: '爆边,爆角' },
            { value: 84, name: 'PVB不良' },
            { value: 44, name: '结石' },
            { value: 44, name: '叠差' },
            { value: 44, name: '表面凹坑' },
            { value: 44, name: '无应力' },
            { value: 44, name: '氩气不足' },
            { value: 300, name: '实物与标签不符' }
          ],
        },
        series: [
          {
            name: '不良项目',
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['40%', '50%'],
            data: [
              { value: 44, name: '无应力' },
              { value: 84, name: '擦伤,划伤' },
              { value: 1048, name: '二次胶不良' },
              { value: 44, name: '膜不良' },
              { value: 735, name: '内脏' },
              { value: 44, name: '氩气不足' },
              { value: 84, name: 'PVB不良' },
              { value: 580, name: '开裂' },
              { value: 44, name: '叠差' },
              { value: 484, name: '变形' },
              { value: 44, name: '结石' },
              { value: 84, name: '爆边,爆角' },
              { value: 300, name: '实物与标签不符' },
              { value: 44, name: '表面凹坑' },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      },
      pieChartLoading:false,
    }
  },
  methods:{
    getDateFormat(){
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString() + "-1"
    },

    renderEcharts(id,option){
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let pieChart = echarts.init(document.getElementById(id));
        pieChart.setOption(option)
      }
    },

    renderAllEcharts(){
      this.getWuJianChart()
      this.getDayChart()
      this.getPieChart()
    },

    async getWuJianInFo() {
      let {data: res} = await this.$axios.post('bus/datasource/getWuJianInFo');
      if (res.code !== 0) {
        this.$message.error('获取【物件信息】失败')
        return;
      }
      this.wuJianNames = res.data;
    },

    async getDayChart() {
      if (!this.dayBad){
        this.dayBad = this.getDateFormat()
      }
      this.dayBadLoading = true
      let search = {
        dayBad:this.dayBad,
        wujian_id:this.wuJianId
      }
      let {data: res} = await this.$axios.post('bus/shouRuBoLi/dayChart',search);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }
      this.optionDayBad.xAxis[0].data = res.data.XDay
      this.optionDayBad.series[0].data = res.data.badNum
      this.optionDayBad.series[1].data = res.data.badPercent
      if (this.optionDayBad.yAxis[0].max < Math.max.apply(null,res.data.badNum)) {
        this.optionDayBad.yAxis[0].max = Math.max.apply(null, res.data.badNum)
        this.optionDayBad.yAxis[0].interval = Math.round(this.optionDayBad.yAxis[0].max / 3)
      }
      this.renderEcharts('dayBadJiaGong',this.optionDayBad)

      this.dayBadLoading = false
    },

    async getWuJianChart() {
      this.wuJianChartLoading = true

      let {data: res} = await this.$axios.post('bus/shouRuBoLi/wuJianChart',this.wuJianId);
      if (res.code !== 0) {
        this.$message.error(res.message)
        this.wuJianChartLoading = false
      }
      this.optionWuJian.xAxis[0].data = res.data.XMonth
      this.optionWuJian.series[0].data = res.data.badNum
      if (this.optionWuJian.yAxis[0].max < Math.max.apply(null,res.data.badNum)) {
        this.optionWuJian.yAxis[0].max = Math.max.apply(null, res.data.badNum)
        this.optionWuJian.yAxis[0].interval = Math.round(this.optionWuJian.yAxis[0].max / 3)
      }
      this.renderEcharts('wuJianJiaGong',this.optionWuJian)

      this.wuJianChartLoading = false
    },

    async getPieChart() {
      if (!this.pieDate.year){
        this.pieDate.year =  new Date().getUTCFullYear().toString()
      }
      this.pieChartLoading = true
      let search = {
        pieDate:this.pieDate,
        wujian_id:this.wuJianId
      }
      let {data: res} = await this.$axios.post('bus/shouRuBoLi/pieChart',search);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }
      this.optionPie.legend.data = res.data
      this.optionPie.series[0].data = res.data
      this.renderEcharts('pieJiaGong',this.optionPie)

      this.pieChartLoading = false
    },
  },

  created() {
    this.getWuJianInFo()
  },

  mounted() {
    this.renderAllEcharts()
  }
}
</script>

<style scoped>
.pageContainer{
  display: flex;
  flex-direction: row;
  overflow: hidden;
}

.asideContainer{
  width: 50%;
  height: 700px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}
.size{
  width: 470px;
  height: 215px
}
.title{
  border-left: 3px solid steelblue;
  height: 25px;
  font-size: 16px;
  padding-left: 10px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>